<template>
  <div>
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <Card style="margin-bottom: 15px">
      <Header ref="header" :config="config" :searchs="searchs" />
      <CheckboxGroup v-model="checkFields">
        <div
          style="display: flex; margin-bottom: 10px"
          v-for="(group, name) in fields"
          :key="name"
        >
          <div style="width: 80px">
            {{ name }}
          </div>
          <div style="flex: 1">
            <Checkbox
              border
              v-for="(item, key) in group"
              style="margin-bottom: 5px"
              :label="key"
              :key="key"
              >{{ item }}
            </Checkbox>
          </div>
        </div>
      </CheckboxGroup>
      <div style="display: flex; margin-left: 80px">
        <Button @click="exportExc" type="primary">{{ $t("export") }}</Button>
        <Button @click="refresh" style="margin-left: 10px" type="primary">{{
          $t("refresh")
        }}</Button>
      </div>
    </Card>
    <cTable
      :config="list.config"
      ref="table"
      :fields="list.fields"
      :methods="list.methods"
    ></cTable>
  </div>
</template>

<script>
import cTable from "@/base/common/index";
import Header from "@/base/common/component/header.vue";
import { getAllClient } from "@/api/user/client";
import { getAllService } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
import { getSelectType, getKeysType, getGroupName } from "@/api/public";
import { getList, getFields, output, del } from "@/api/order/customExport";
import { getAgent } from "@/api/tracker/agent";
import { getStatus } from "@/api/tracker/status";
import { getCompanyConfig } from "@/api/user/branch";
export default {
  components: {
    Header,
    cTable
  },
  async mounted() {
    getFields().then(res => {
      console.log(res);
      this.fields = res.data.payload.fields;
      this.checkFields = res.data.payload.selected.split(",");
    });
    let service = (await getAllService()).data.payload;
    const from_country = (await getCountry({ allow_depart: 1 })).data.payload
      .rows;
    const to_country = (await getCountry({ allow_arrive: 1 })).data.payload
      .rows;
    const options = (
      await getSelectType([
        "COD_TYPE",
        "NEXT_STEP_TYPE",
        "ORDERS_TYPE",
        "OUTBOUND_SELECT_TYPE",
        "ORDER_STATUS"
      ])
    ).data.payload;
    const deliver = (
      await getAgent({
        agent_type: "bag",
        status: "YES",
        types: "DELIVERY"
      })
    ).data.payload.rows;
    const status = (await getStatus()).data.payload.rows;
    const ownership = (await getCompanyConfig("company")).data.payload.company;
    this.searchs.forEach(item => {
      if (item.key === "service_id") {
        let arr = [1, 2, 3];
        let data = [];
        arr.forEach(t => {
          data = data.concat(service[t]);
        });
        item.options = data;
      } else if (item.key === "salesmanId") {
        item.options = service[5];
      }
      if (item.key === "from_country") item.options = from_country;
      if (item.key === "to_country") item.options = to_country;
      if (item.key === "current_processor")
        item.options = options["NEXT_STEP_TYPE"];
      if (item.key === "type") item.options = options["ORDERS_TYPE"];
      if (item.key === "deliver") item.options = deliver;
      if (item.key === "status") item.options = status;
      if (item.key === "code_status") item.options = options["ORDER_STATUS"];
      if (item.key === "ownership") item.options = ownership;
      if (item.key === "codType") item.options = options["COD_TYPE"];
      if (item.key === "package_type")
        item.options = options["OUTBOUND_SELECT_TYPE"];
    });
    this.loading = false;
  },
  methods: {
    refresh() {
      this.$refs["table"].getList();
    },
    exportExc() {
      console.log(this.$refs["header"], this.formData);
      console.log(this.$refs["header"].handleFilterData());
      let data = Object.assign(
        { fields: this.checkFields.join(",") },
        this.$refs["header"].handleFilterData()
      );

      this.loading = true;
      output(data).then(res => {
        console.log(res);
        this.loading = false;
        if (res.data.status) {
          this.refresh();
        }
      });
    }
  },
  data() {
    return {
      loading: true,
      checkFields: [],
      fields: {},
      config: {
        searchLength: 30,
        hideSubmit: true,
        custom: false
      },
      searchs: [
        {
          key: "timeType",
          placeholder() {
            return this.$t("select") + this.$t("date") + this.$t("type");
          },
          clearable: false,
          component: "Select",
          options: [
            { value: 1, label: this.$t("createTime") },
            { value: 2, label: this.$t("inboundTime") },
            { value: 3, label: this.$t("outbound_time") },
            { value: 4, label: this.$tz("轨迹时间") },
            { value: 5, label: this.$tz("装袋,时间") }
          ]
        },
        {
          key: "startTime",
          component: "DatePicker",
          placeholder() {
            return (
              this.$t("select") +
              this.$t("start") +
              this.$t("date") +
              this.$t("time")
            );
          },
          bind: {
            type: "datetime",
            options: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            },
            style: {
              width: "175px"
            }
          },
          methods: {
            "on-change"({ searchForm }) {
              searchForm.startTime = searchForm.startTime
                ? this.$page.format.timeFormat(searchForm.startTime)
                : "";
            }
          }
        },
        {
          key: "endTime",
          component: "DatePicker",
          placeholder() {
            return (
              this.$t("select") +
              this.$t("end") +
              this.$t("date") +
              this.$t("time")
            );
          },
          bind: {
            type: "datetime",
            options: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            },
            style: {
              width: "175px"
            }
          },
          methods: {
            "on-change"({ searchForm }) {
              let time = this.format.timeFormat(searchForm.endTime);
              if (time.slice(-8) === "00:00:00") {
                time = time.split(" ")[0] + " " + "23:59:59";
                searchForm.endTime = time;
              }
            }
          }
        },
        {
          key: "client_id",
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("clientName");
          },
          clearable: true,
          options: [],
          bind: {
            style: "width:150px"
          },
          config: { label: "account", value: "id" },
          methods: {
            async list({ field, row }) {
              let res = (await getAllClient()).data.payload.rows;
              field.options = res;
              this.$forceUpdate();
            }
          }
        },
        {
          key: "salesmanId",
          component: "Select",
          bind: {
            style: "width:150px"
          },
          placeholder() {
            return this.$t("salesman");
          },
          options: []
        },
        {
          key: "service_id",
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("serviceAccount");
          },
          options: []
        },
        {
          name: this.$tz("仓库"),
          key: "warehouse_id",
          component: "Select",
          placeholder: () => this.$tz("仓库"),
          options: [],
          optionsFn: "warehouseSelect",
          optionsKey: "",
          default: ""
        },
        {
          key: "from_country",
          component: "Select",
          placeholder() {
            return this.$t("allow_depart");
          },
          clearable: true,
          options: [],
          config: { label: "code", value: "code" }
        },
        {
          key: "to_country",
          component: "Select",
          placeholder() {
            return this.$t("allow_arrive");
          },
          clearable: true,
          options: [],
          config: { label: "code", value: "code" }
        },
        {
          key: "current_processor",
          component: "Select",
          bind: {
            style: "width:150px"
          },
          placeholder() {
            return this.$t("NextProcessing");
          },
          options: []
        },
        {
          key: "deliver",
          component: "Select",
          bind: {
            style: "width:150px"
          },
          placeholder() {
            return this.$t("localFaction");
          },
          options: [],
          config: {
            label: "agent_name",
            value: "agent_name"
          }
        },
        {
          key: "type",
          component: "Select",
          bind: {
            style: "width:150px",
            multiple: true,
            "max-tag-count": 1
          },
          placeholder() {
            return this.$t("order_type_t");
          },
          options: []
        },
        {
          key: "status",
          component: "Select",
          bind: {
            style: "width:150px"
          },
          placeholder() {
            return this.$t("tracker_code");
          },
          options: [],
          config: { label: "tracker_code", value: "tracker_code" }
        },
        {
          key: "code_status",
          component: "Select",
          bind: {
            style: "width:150px"
          },
          placeholder() {
            return this.$t("orderType");
          },
          options: []
        },
        {
          key: "codType",
          component: "Select",
          bind: {
            style: "width:150px"
          },
          placeholder() {
            return this.$t("order_type");
          },
          options: []
        },
        {
          key: "ownership",
          component: "Select",
          placeholder() {
            return this.$t("ownership");
          },
          clearable: true,
          options: [],
          config: { label: "title", value: "id" }
        },
        {
          key: "package_type",
          component: "Select",
          placeholder() {
            return this.$t("packageType");
          },
          clearable: true,
          options: []
        },
        {
          key: "keywordsType",
          placeholder() {
            return this.$tz("单号，类型");
          },
          component: "Select",
          options: [
            { value: 1, label: this.$tz("订单号码") },
            { value: 2, label: this.$tz("客户,单号") }
          ],
          optionsFn: "",
          optionsKey: "",
          default: 1
        },
        {
          key: "awbnos",
          placeholder() {
            return this.$tz("单号");
          },
          bind: {
            type: "textarea",
            rows: 2
          },
          component: "Input"
        }
      ],
      list: {
        methods: {
          list: getList,
          del
        },
        config: {
          height: 500,
          resize: false
        },
        fields: [
          {
            name: this.$t("field"),
            key: "fields_cn"
          },
          {
            name: this.$t("tip"),
            key: "result",
            width: 100,
            methods: {
              render({ value }) {
                let type = ["waiting", "finished", "error"];
                return this.$t(type[value]);
              }
            }
          },
          {
            name: this.$t("information"),
            key: "msg"
          },
          {
            name: this.$t("createTime"),
            key: "create_time",
            width: 160
          },
          {
            name: () => this.$t("operation"),
            type: "btns",
            width: 220,
            fixed: "right",
            list: [
              {
                name: this.$tz("下载"),
                type: "download",
                fnName: "download",
                disabled({ row }) {
                  return !row.url;
                },
                bind: {
                  type: "primary"
                }
              },
              {
                name: this.$tz("删除"),
                type: "del",
                fnName: "del",
                bind: {
                  type: "error"
                }
              }
            ],
            methods: {
              download({ row }) {
                this.openUrl(row.url);
              },
              del({ row }) {
                this.$Modal.confirm({
                  title: this.$tz("删除"),
                  width: 300,
                  content: this.$t("titleModal"),
                  onOk: () => {
                    this.handleRequestMethods("del", row.id, true, true).then(
                      res => {
                        this.getList();
                      }
                    );
                  }
                });
              }
            }
          }
        ]
      }
    };
  }
};
</script>

<style scoped></style>
